import React from 'react';

import { SVGComponentProps } from './svg.types';

const ConnectorSVG = ({
  fill = 'currentColor',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="30"
        height="26"
        viewBox="0 0 30 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.1245 7.99905C5.01785 7.99905 2.4995 10.5174 2.4995 13.6241C2.4995 16.7306 5.01785 19.249 8.1245 19.249H20.1618C20.7165 17.0925 22.6733 15.4991 25.0019 15.4991C27.762 15.4991 29.9995 17.7376 29.9995 20.499C29.9995 23.2604 27.762 25.499 25.0019 25.499C22.6733 25.499 20.7165 23.9056 20.1618 21.749H8.1245C3.63717 21.749 -0.000554085 18.1113 -0.000554085 13.6241C-0.000554085 9.13673 3.63717 5.49902 8.1245 5.49902H25.7322L22.8661 2.63291C22.378 2.14475 22.378 1.3533 22.8661 0.865138C23.3543 0.376985 24.1457 0.376985 24.6339 0.865138L29.6339 5.86515C29.8683 6.09953 30 6.41753 30 6.74903C30 7.08053 29.8683 7.39845 29.6339 7.6329L24.6339 12.6329C24.1457 13.121 23.3543 13.121 22.8661 12.6329C22.378 12.1448 22.378 11.3533 22.8661 10.8651L25.7322 7.99905H8.1245ZM25.0019 17.999C23.6237 17.999 22.5044 19.1171 22.5044 20.499C22.5044 21.8809 23.6237 22.999 25.0019 22.999C26.3801 22.999 27.4995 21.8809 27.4995 20.499C27.4995 19.1171 26.3801 17.999 25.0019 17.999V17.999Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default ConnectorSVG;
